import React from 'react';

import { PopoverPlacement } from '@rover/components/src/callouts/Popover/popover.constants';
import { Box } from '@rover/kibble/core';
import Avatar from '@rover/kibble/patterns/Avatar';
import SitterBadge from '@rover/react-lib/src/pages/search/shared/components/SitterBadge';
import type { SitterBadge as SitterBadgeType } from '@rover/types/src/SitterBadge';

const AVATAR_SIZE = '20x';
const BADGE_SIZE = '6x';

interface GroomingAvatarColumnProps {
  imageUrl: string;
  shortName: string;
  badge?: SitterBadgeType;
}

function GroomingAvatarColumn({
  imageUrl,
  shortName,
  badge,
}: GroomingAvatarColumnProps): React.ReactElement {
  const description = `Groomer Profile Image: ${shortName}`;

  return (
    <Box position="relative" flexShrink="0">
      <Avatar
        imageUrl={imageUrl}
        type="person"
        width={AVATAR_SIZE}
        height={AVATAR_SIZE}
        alt={description}
      />
      {badge && (
        <Box position="absolute" bottom="0" right="0" width={BADGE_SIZE} height={BADGE_SIZE}>
          <SitterBadge
            title={badge.title}
            content={badge.content}
            imageUrl={badge.imageUrl}
            slug={badge.slug}
            width={24}
            popoverPlacement={PopoverPlacement.RIGHT}
          />
        </Box>
      )}
    </Box>
  );
}

export default GroomingAvatarColumn;
